// extracted by mini-css-extract-plugin
export default {"badge":"MicrositeSystemBadge_badge__F+6JQ"};